export default "__VITE_ASSET__C2V2TyJs__"